// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_4h-0";
export var orangeButton = "_4h-1";